module.exports = __webpack_public_path__ + "static/media/action-response-bg.82e5e831.svg";